import {
    SET_ALL_COLUMNS,
    SET_COUNT,
    SET_DATA,
    SET_FILTER_METHODS,
    SET_GROUPING_METHODS,
    SET_PAGE,
} from "../Actions/Types/queryToolActionTypes";
import {service as QueryToolService} from "../../Services/QueryToolService";
import {service as GroupingMethodService} from "../../Services/GroupingMethodService";
import {service as FilterMethodService} from "../../Services/FilterMethodService";
import {selectQueryDefinition, selectQueryToolCount} from "../Selectors/queryToolSelectors";

export const fetchQueryToolMetadata = () => async dispatch => {
    try {
        const [columnSources, groupingMethods, filterMethods] = await Promise.all([
            QueryToolService.Get(),
            GroupingMethodService.Get(),
            FilterMethodService.Get(),
        ]);

        dispatch({
            type: SET_ALL_COLUMNS,
            availableColumnSources: columnSources.result.filter(source => !source.hidden),
        });
        dispatch({
            type: SET_GROUPING_METHODS,
            groupingMethods: groupingMethods.result,
        });
        dispatch({
            type: SET_FILTER_METHODS,
            filterMethods: filterMethods.result,
        });
    } catch (error) {
        console.error('Failed to load query tool metadata', error);
    }
};

export const fetchQueryToolData = ({withCount = true} = {}) => async (dispatch, getState) => {
    const state = getState();
    const definitionFromState = selectQueryDefinition(state);
    const definition = {
        ...definitionFromState,
        columns: definitionFromState.columns.map(column => ({...column})),
    };

    // Reset page back to first page on new queries
    if (withCount) {
        definition.page = 0;
    }

    try {
        const {result, count = null} = await QueryToolService.QueryData(definition, withCount);
        const fallbackCount = selectQueryToolCount(state);

        dispatch({type: SET_DATA, data: result});
        dispatch({type: SET_COUNT, count: count ?? fallbackCount});
        dispatch({type: SET_PAGE, page: definition.page});
    } catch (error) {
        console.error('Failed to load query tool data', error);
    }
};
